import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  "kompletní PDF e-book",
  "všech 40 propracovaných principů",
  "5 hlavních oblastí života",
  "konkrétní příklady a situace",
  "praktické úkoly",
  "otázky k zamyšlení",
  "okamžitý přístup po zaplacení",
];

export const WhatYouGet = () => (
  <section className="bg-cream py-28 text-navy-deep sm:py-36" data-testid="what-you-get-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Reveal>
          <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-bronze">
            <span className="h-px w-10 bg-bronze/60" aria-hidden="true" />
            Shrnutí
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            Co přesně <span className="italic text-bronze">získáš</span>
          </h2>
        </Reveal>
        <ul className="mt-12 space-y-1">
          {ITEMS.map((item, i) => (
            <Reveal key={item} delay={0.05 * i} y={12}>
              <li className="flex items-center gap-4 border-b border-navy-deep/[0.08] py-4">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-bronze/40">
                  <Check className="h-3.5 w-3.5 text-bronze" strokeWidth={2.5} aria-hidden="true" />
                </span>
                <span className="text-base text-navy-deep/85 sm:text-lg">{item}</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-5">
        <Reveal delay={0.15}>
          <div className="relative mx-auto max-w-xs">
            <div
              aria-hidden="true"
              className="absolute -inset-6 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(166,124,82,0.18),transparent_65%)]"
            />
            <img
              src="/assets/ebook-cover-small.webp"
              width={544}
              height={768}
              loading="lazy"
              alt="Obálka PDF e-booku 40 principů lepšího muže"
              className="relative w-full rounded-sm shadow-[0_30px_60px_-15px_rgba(18,21,26,0.4)]"
              data-testid="product-cover"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
